import { LocalizedText } from "../../../components/LocalizedText";
import * as React from 'react';
import { NpcMenu } from '../../../components/NpcMenu/NpcMenu';
import { useAppSelector } from '../../../hooks';
import { toServer } from '../../../util/ServerSocket';

export const NpcMenuArena: React.FC<{ onEnd: () => void }> = ({ onEnd }) => {
  const enterArena = React.useCallback(() => toServer('switchScene', 2), []);
  const [talkId, setTalkId] = React.useState('');
  const server = useAppSelector((state) => state.account.serverId);

  let content = (() => {
    switch (talkId) {
      case '1':
        return (
          <>
            <div className="clickable" onClick={() => toServer('huntBegin')}><LocalizedText text={"Begin Hunt"} /></div>
            <div className="clickable" onClick={() => toServer('huntComplete')}><LocalizedText text={"Finish Hunt"} /></div>
            <div className="clickable" onClick={() => setTalkId('')}><LocalizedText text={"Back"} /></div>
          </>
        );
      default:
        return (
          <>
            <div className="clickable" onClick={enterArena}><LocalizedText text={"Enter Arena"} /></div>
            {server === 2 && (
              <div className="clickable" onClick={() => setTalkId('1')}><LocalizedText text={"Hunt Monsters"} /></div>
            )}
          </>
        );
    }
  })();

  return (
    <NpcMenu onEnd={onEnd} npc={11002} talkId={talkId}>
      {content}
    </NpcMenu>
  );
};
